import React from 'react'
import { AccordionCard } from 'components/AccordionCard'
import { Box, Flex, Text, useAppTheme } from '@workwhile/ui'

import { useDayforceJobContextValue } from 'pages/Dayforce/shared/context/DayforceJobProvider'
import { useDayforceAgenciesContextValue } from 'pages/Dayforce/shared/context/DayforceAgenciesProvider'

export const GeneralDetails = ({
  actionsBlock,
}: {
  actionsBlock?: React.ReactNode
}) => {
  const { space } = useAppTheme()

  const {
    state: { agencies },
  } = useDayforceAgenciesContextValue()
  const {
    state: { data },
  } = useDayforceJobContextValue()

  return (
    <Flex gap={3} flexWrap="wrap" flexDirection="row">
      <Box style={{ flex: 1 }}>
        <AccordionCard
          title="Job details"
          size="large"
          contentWrapperProps={{
            display: 'flex',
            flexDirection: 'column',
            gap: space[2],
          }}
        >
          <Text>
            <Text as="span" fontWeight="bold">
              Agency:{' '}
            </Text>
            {agencies[data.agencyId]?.name || 'Unknown'} ({data.agencyId})
          </Text>
          <Text>
            <Text as="span" fontWeight="bold">
              Job ID:{' '}
            </Text>
            {data.jobId}
          </Text>
          <Text>
            <Text as="span" fontWeight="bold">
              Client name:{' '}
            </Text>
            {data.clientName}
          </Text>
          <Text>
            <Text as="span" fontWeight="bold">
              Job status:{' '}
            </Text>
            {data.jobStatus}
          </Text>
        </AccordionCard>
      </Box>
      <Box>
        <AccordionCard
          title="Actions"
          size="large"
          contentWrapperProps={{
            display: 'flex',
            flexDirection: 'column',
            gap: space[2],
          }}
        >
          {actionsBlock}
        </AccordionCard>
      </Box>
    </Flex>
  )
}
